import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useState, useEffect } from "react";

import './App.css';

import Nav from './components/Nav';
import Footer from './components/Footer';
import SparklesBackground from './components/SparklesBackground';
import Loader from "./components/Loader";

import { HelmetProvider } from 'react-helmet-async';
import SeoManager from "./SeoManager";


import Naslovna from './pages/Naslovna';
import Onama from './pages/Onama';
import WebShop from './pages/WebShop';
import Pojasevi from './pages/Pojasevi';
import GalerijaPage from "./pages/GalerijaPage";
import Kontakt from './pages/Kontakt';
import DizajnVolana from './pages/DizajnVolana';
import ScrollToTopButton from './components/ScrollToTopButton';

function App() {
  const [loading, setLoading] = useState(true);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setFade(true);
      setTimeout(() => setLoading(false), 600);
    }, 2000);
  }, []);

  if (loading) return <Loader fade={fade} />;

  return (
    <HelmetProvider>
    <BrowserRouter>
    <SeoManager />
      <Nav />
      <SparklesBackground />

      <Routes>
        <Route path="/" element={<Naslovna />} />
        <Route path="/onama" element={<Onama />} />
        <Route path="/webshop" element={<WebShop />} />
        <Route path="/usluge/pojasevi" element={<Pojasevi />} />
        <Route path="/galerija" element={<GalerijaPage />} />
        <Route path="/kontakt" element={<Kontakt />} />
        <Route path="/usluge/custom-dizajn-volana" element={<DizajnVolana />} />
      </Routes>

      <ScrollToTopButton />
      <Footer />
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;